import ReportSelect from "./ReportSelect";

function FlowieOZero(props) {
  return <ReportSelect type={"flowie-o-zero-report"} />;
}

export default FlowieOZero;
